import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LogInstanceToken } from '@evorait/pace-logging';
import { MeasurementToolsService } from '../../services/measurement-tools.service';
import {
    loadODataMeasurementTools,
    loadODataMeasurementToolsSuccess,
    loadODataMeasurementToolsFailure,
} from '../actions/measurement-tools.action';

@Injectable({
    providedIn: 'root',
})
export class MeasurementToolsEffectsService {
    private readonly actions$ = inject(Actions);
    private readonly measurementToolsService = inject(MeasurementToolsService);
    private readonly log = inject(LogInstanceToken);

    public loadMeasurementTools$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadODataMeasurementTools),
            switchMap(() =>
                this.measurementToolsService.getMeasurementTools().pipe(
                    map((measurementTools) => loadODataMeasurementToolsSuccess({ measurementTools })),
                    catchError((error) => {
                        this.log.error(
                            `MeasurementToolsEffectsService: loadMeasurementTools$: error: ${JSON.stringify(
                                error,
                                Object.getOwnPropertyNames(error),
                            )}`,
                        );
                        return of(loadODataMeasurementToolsFailure());
                    }),
                ),
            ),
        ),
    );
}
